/* eslint-disable jsx-a11y/anchor-is-valid */
import { Form, Popconfirm, Tooltip } from "antd";
import { useState, useRef } from "react";
import { Button, Input, Table, Select, Row, Col } from "antd";
// import Sidebar from "../../../components/AdminComponents/SideNav";
// import { useParams } from "react-router-dom";
// import {
//   ClientMenu,
//   SecondaryNavClient,
// } from "../../../components/AdminComponents/MenuItems";

import {
  DeleteTwoTone,
  CheckOutlined,
  PlusOutlined,
  MinusOutlined,
  PlusCircleOutlined,
  CloseOutlined,
  CheckCircleFilled,
  SwapOutlined,
} from "@ant-design/icons";
import "../../../pages/Admin-pages/tableStyling.css";
import ExpanedFirstRow from "./ExpandedFirstRow";
import EditableImage from "../../icons/EditIcon";
import Axios from "../../../api/Axios";
import { useSelector } from "react-redux";
import "./modalstyles.css";
import { getUpdateStatus } from "../ViewUpdateIndex";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../icons/ApplicationColor";
import DeactivationModal from "./DeactivationModal";

const { Option } = Select;

const ParentTable = (props) => {
  const { isCustomerSummary = false } = props;
  // console.log(props.data[0].id);
  //   const { id } = useParams();
  const [newProductRowIndex, setNewProductRowIndex] = useState([
    false,
    false,
    false,
    false,
  ]);
  const userInfo = useSelector((state) => state.user);
  const updateAuth = getUpdateStatus(userInfo, 0, 4);
  //console.log(props.manager);
  const [test, setTest] = useState(false);
  const [top, setTop] = useState(false);
  //   const [top, setTop] = useState(false);

  // const handleParentRowClose = (key) => {
  //   setExpandedRows({
  //     ...expandedRows,
  //     [key]: true,
  //   });
  // };
  // const [secondRowIndex, setsecondRowIndex] = useState(-1);
  // const setRowSecond = (index) => {
  //   setsecondRowIndex(index);
  // };
  //

  // eslint-disable-next-line no-unused-vars
  const expandIcon = ({ expanded, onExpand, record }) =>
    expanded ? (
      <MinusOutlined onClick={(e) => onExpand(record, e)} />
    ) : (
      <PlusOutlined onClick={(e) => onExpand(record, e)} />
    );
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [initialHirearchy, setInitialHirearchy] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [level, setLevel] = useState("");
  const isEditing = (record) => record.id === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      ...record,
      manager: record?.manager?.id,
    });
    setEditingKey(record.id);
    setInitialHirearchy(record?.entity_id);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const deleteRecord = (record) => {
    //console.log("IN Delete Record")
    setLevel("level1");
    if (record.user_count === 0 && record.division_count === 0) {
      onDelete(record);
    } else {
      setSelectedRecord(record);
      setModalVisible(true);
    }
  };
  const handleDeactivation = (record) => {
    onDelete(record);
    setModalVisible(false);
  };

  const handleCancelModal = () => {
    setModalVisible(false);
  };
  const restoreRecord = (record) => {
    onRestore(record);
  };
  const onRestore = async (record) => {
    const data = {
      status: true,
      organization: isCustomerSummary ? props.organizationId : userInfo.data.organization.id,
      entity_level: record.entity_level,
      updated_by: userInfo?.data?.id,
    };
    try {
      await Axios.put(
        `${isCustomerSummary ? "/customer" : ""}/entity/${record.id}/`,
        data,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      cancel();
      if (isCustomerSummary && props.refreshData) props.refreshData();
      props.CreateSuccessfull("Entity level has been edited");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Entity level status has not been edited"
      );
    }
  };

  // eslint-disable-next-line no-unused-vars
  const [applications, setApplications] = useState([]);
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode =
      inputType === "select" ? (
        <Select placeholder="Select Manager" disabled={!props.active}>
          <Option key={"null"} value={"none"}>
            None
          </Option>
          {props.manager?.map((app) => (
            <Option key={app.id} value={app.id}>
              {app.full_name}
            </Option>
          ))}
        </Select>
      ) : (
        <Input disabled={!props.active} />
      );

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={
              dataIndex === "entity_id"
                ? [
                    {
                      validator: checkUserExists2,
                      validateTrigger: "onChange",
                    },
                  ]
                : dataIndex !== "manager"
                ? [
                    {
                      required: true,
                      message: `Please Input ${title}!`,
                    },
                  ]
                : undefined // ✅ explicitly set undefined for 'manager'
            }
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  // eslint-disable-next-line no-unused-vars
  const onDelete = async (record) => {
    //console.log("In delete in parent table")
    //console.log("In delete in parent table level",level)
    if (level === "level1") {
      //console.log(record, "THIS IS THE RECORD");
      try {
        const data = {
          status: false,
          organization: isCustomerSummary ? props.organizationId : userInfo.data.organization.id,
          entity_level: record.entity_level,
          updated_by: userInfo?.data?.id,
        };
        await Axios.put(
          `${isCustomerSummary ? "/customer" : ""}/entity/${record.id}/`,
          data,
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        //console.log(res)
        cancel();
        if (isCustomerSummary && props.refreshData) props.refreshData();
        props.CreateSuccessfull("Entity level has been Archived");
      } catch (err) {
        //console.log(err);
        props.CreateFailed(
          err?.response?.data?.detail || "Entity level has not been Archived "
        );
      }
    } else if (level === "level2") {
      const data = {
        status: false,
        entity: record.id,
        div_level: record.div_level,
        updated_by: userInfo?.data?.id,
      };
      try {
        await Axios.put(
          `${isCustomerSummary ? "/customer" : ""}/division/${record.id}/`,
          data,
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        //console.log(res);
        cancel();
        if (isCustomerSummary && props.refreshData) props.refreshData();
        props.CreateSuccessfull("Division level has been Archived");
      } catch (err) {
        //console.log(err);
        props.CreateFailed(
          err?.response?.data?.detail || "Division level has not been Archived"
        );
      }
    } else if (level === "level3") {
      const data = {
        status: false,
        division: record.div_level,
        dep_level: record.dep_level,
        updated_by: userInfo?.data?.id,
      };
      try {
        await Axios.put(
          `${isCustomerSummary ? "/customer" : ""}/department/${record.id}/`,
          data,
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        //console.log(res);
        cancel();
        if (isCustomerSummary && props.refreshData) props.refreshData();
        props.CreateSuccessfull("Department level has been Archived");
      } catch (err) {
        //console.log(err);
        props.CreateFailed(
          err?.response?.data?.detail ||
            "Department level has not been Archived"
        );
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish21 = async (values) => {
    const row = await form.validateFields();

    if (isCustomerSummary) {
      const payload = {
        entity_name: row.entity_name,
        entity_id: row.entity_id,
        organization: props.organizationId,
        entity_level: values.entity_level,
        updated_by: userInfo?.data?.id,
      };

      try {
        await Axios.put(`/customer/entity/${values.id}/`, payload, {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        });
        cancel();
        if (props.refreshData) props.refreshData();
        props.CreateSuccessfull("Entity level has been edited");
      } catch (err) {
        props.CreateFailed(
          err?.response?.data?.detail || "Entity level has not been edited"
        );
      }
      return;
    }

    row.organization = userInfo.data.organization.id;
    row.entity_level = values.entity_level;
    row.updated_by = userInfo?.data?.id;
    for (const key in row) {
      if (row.hasOwnProperty(key) && row[key] === "none") {
        row[key] = ""; // Replace "none" with an empty string
      }
    }
    try {
      await Axios.put(`/entity/${values.id}/`, row, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      cancel();
      props.CreateSuccessfull("Entity level has been edited");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Entity level has not been edited"
      );
    }
    //console.log(row);
    //console.log(values);
  };

  const handleRowClick = (record) => {
    // Navigate to the details page using React Router
    edit(record);
  };
  const columns = [
    {
      title: capitalizeWords("HIERARCHY NAME"),
      dataIndex: "entity_name",
      key: "entity_name",
      width: 150, // set width to 150px
      editable: true,
    },
    {
      title: capitalizeWords("LEVEL"),
      dataIndex: "entity_level",
      key: "entity_level",
      width: 150, // set width to 150px
      // editable: true,
    },
    {
      title: capitalizeWords("HIERARCHY ID"),
      dataIndex: "entity_id",
      key: "entity_id",
      width: 150, // set width to 150px
      editable: true,
    },
    {
      title: capitalizeWords("STRUCTURES"),
      dataIndex: "division_count",
      key: "division_count",
      width: 100, // set width to 150px
      align: "center",
      // editable: true,
    },
    {
      title: capitalizeWords("EMPLOYEES"),
      dataIndex: "user_count",
      key: "user_count",
      width: 80, // set width to 150px
      align: "center",
      // editable: true,
    },
    {
      title: capitalizeWords("MANAGER"),
      dataIndex: "manager",
      key: "manager",
      width: 150, // set width to 150px
      editable: true,
      render: (text, record) => {
        // Render logic for the manager column
        return <div>{record?.manager?.full_name}</div>;
      },
    },
    ...(updateAuth
      ? [
          {
            title: capitalizeWords("ACTIONS"),
            dataIndex: "operation",
            width: 80,
            align: "center",
            render: (_, record) => {
              //console.log(record);
              const editable = isEditing(record);
              return editable ? (
                <div>
                  {props.active && (
                    <CheckCircleFilled
                      title="submit"
                      style={{
                        color: "#52c41a",
                        fontSize: "1.8rem",
                        fontWeight: "700",
                      }}
                      onClick={() => onFinish21(record)}
                    />
                  )}

                  <Popconfirm
                    title={
                      props?.active
                        ? "Confirm to Deactivate"
                        : "Confirm to Restore"
                    }
                    onConfirm={() => {
                      props.active
                        ? deleteRecord(record)
                        : restoreRecord(record);
                    }}
                  >
                    {props.active ? (
                      <>
                        {isCustomerSummary || record?.can_be_deleted ? (
                            <DeleteTwoTone
                              style={{
                                cursor: "pointer",
                                fontSize: "1.8rem",
                                marginLeft: "0.9rem",
                              }}
                              title="delete"
                              twoToneColor="#eb2f96"
                            />
                        ) : null}
                      </>
                    ) : (
                      <>
                        <SwapOutlined
                          style={{
                            cursor: "pointer",
                            fontSize: "1.8rem",
                            marginLeft: "0.9rem",
                          }}
                          // onClick={() => {
                          //   handleDelete(record);
                          // }}
                          title="Restore"
                        />
                      </>
                    )}
                  </Popconfirm>
                  <CloseOutlined
                    onClick={() => {
                      cancel();
                    }}
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                  />
                </div>
              ) : record?.update?.edit ? (
                <>
                  <Tooltip title={`EDIT - ${record?.entity_level}`}>
                    <div style={{ marginLeft: "2.5px" }}>
                      <EditableImage
                        handleRowClick={handleRowClick}
                        recordId={record}
                        disabled={editingKey !== ""}
                      />
                    </div>
                  </Tooltip>
                </>
              ) : null;
            },
          },
        ]
      : []),
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "manager" ? "select" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // const data = [
  //   {
  //     key: "0",
  //     name: "Screen",
  //     platform: "iOS",
  //     version: "10.3.4.5654",
  //     upgradeNum: 500,
  //     creator: "Jack",
  //     createdAt: "Willows",
  //   },
  //   {
  //     key: "1",
  //     name: "Screen 2",
  //     platform: "Android",
  //     version: "11.0.0",
  //     upgradeNum: 1000,
  //     creator: "Jane",
  //     createdAt: "Oak",
  //   },
  //   {
  //     key: "2",
  //     name: "Screen 3",
  //     platform: "Web",
  //     version: "2.1.0",
  //     upgradeNum: 200,
  //     creator: "John",
  //     createdAt: "Maple",
  //   },
  // ];
  const namingData = useSelector((state) => state.orgdeatil);
  //console.log(namingData);
  const formRef2 = useRef();

  // eslint-disable-next-line no-unused-vars

  const handleReset = () => {
    formRef2.current.resetFields();
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  const csrfToken = getCookie("csrftoken");
  const onFinish2 = async (values) => {
    //console.log(values);
    for (const key in values) {
      if (values.hasOwnProperty(key)) {
        // Check if the value is undefined
        if (values[key] === undefined) {
          // Update undefined value to null
          values[key] = null;
        }
      }
    }
    values.organization = isCustomerSummary ? props.organizationId : userInfo.data.organization.id;
    values.created_by = userInfo?.data?.id;

    const endpoint = isCustomerSummary ? "/customer/entitycreate/" : "/entitycreate/";

    try {
      await Axios.post(endpoint, values, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      //console.log(res);
      setTop(false);
      handleReset();
      if (props.refreshData) props.refreshData();
      props.CreateSuccessfull("Entity level has been created");
    } catch (err) {
      //console.log(err);
      props.CreateFailed(
        err?.response?.data?.detail || "Entity level has not been created"
      );
    }
  };
  const [isUserExists2, setIsUserExists2] = useState(false);
  const handleFormChange2 = async (changedValues, allValues) => {
    if ("entity_id" in changedValues && allValues.entity_id.length > 0) {
      if (allValues.entity_id === initialHirearchy) {
        setIsUserExists2(false);
      } else {
        const orgId = isCustomerSummary
          ? props.organizationId
          : userInfo.data.organization.id;
        const response = await Axios.get(
          `/orgstructurecheck/${orgId}/?hierarchy=Level1&search=${allValues.entity_id}`
        );
        //console.log(response);
        setIsUserExists2(response.data.exists);
        //console.log(isUserExists2);
      }
    } else {
      setIsUserExists2(false);
    }
  };
  const checkUserExists2 = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists2 === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists2().then(resolve, reject);
        }, 100);
      } else if (isUserExists2) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };

  const [isUserExists, setIsUserExists] = useState(false);
  const handleFormChange = async (changedValues, allValues) => {
    if ("entity_id" in changedValues && allValues.entity_id.length > 0) {
      const orgId = isCustomerSummary
        ? props.organizationId
        : userInfo.data.organization.id;
      const response = await Axios.get(
        `/orgstructurecheck/${orgId}/?hierarchy=Level1&search=${allValues.entity_id}`
      );
      //console.log(response);
      setIsUserExists(response.data.exists);
      //console.log(isUserExists);
    }
  };
  const checkUserExists = () => {
    return new Promise(async (resolve, reject) => {
      if (isUserExists === undefined) {
        // API call has not completed yet, wait for it to complete and try again
        setTimeout(() => {
          checkUserExists().then(resolve, reject);
        }, 100);
      } else if (isUserExists) {
        reject("Client already exists");
      } else {
        resolve();
      }
    });
  };
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  return (
    <div>
      <Form
        form={form}
        component={false}
        onFinish={onFinish21}
        onValuesChange={handleFormChange2}
      >
        <Table
          bordered
          size="small"
          pagination={false}
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          dataSource={props.data}
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(30)}px`,
          }}
          expandable={{
            expandIcon,
            onExpand: (expanded, record) => {
              setExpandedRowKeys((prevKeys) => {
                if (expanded) {
                  return [...prevKeys, record.id];
                } else {
                  return prevKeys.filter((key) => key !== record.id);
                }
              });
            },
          }}
          rowKey="id"
          rowClassName={(record, index) =>
            expandedRowKeys.includes(record.id)
              ? "editable-row expanded-row-table-row"
              : "editable-row"
          }
          className="table-container-nocolor"
          style={{ margin: "1rem" }}
          // expandableRowIcon={<PlusOutlined type="right" />}
          // collapsedRowIcon={<PlusOutlined type="down" />}
          expandedRowRender={(record, index) => {
            return (
              <ExpanedFirstRow
                isCustomerSummary={isCustomerSummary}
                organizationId={props.organizationId}
                refreshData={props.refreshData}
                record={record}
                index={index}
                setNewProductRowIndex={setNewProductRowIndex}
                newProductRowIndex={newProductRowIndex}
                test={test}
                data={props.data[index]?.division}
                setTest={setTest}
                CreateSuccessfull={props.CreateSuccessfull}
                CreateFailed={props.CreateFailed}
                entityID={props.data[index]?.id}
                manager={props.managerL2}
                managerL3={props.managerL3}
                active={props.active}
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                selectedRecord={selectedRecord}
                setSelectedRecord={setSelectedRecord}
                level={level}
                setLevel={setLevel}
              />
            );
          }}
        />
      </Form>
      {!top &&
        updateAuth &&
        props.active &&
        props?.data?.length > 0 &&
        props?.data?.[0]?.update?.add && (
          <Button
            onClick={() => {
              setTop(true);
            }}
            style={{
              background: "white",
              fontWeight: "500",
              fontSize: "1.4rem",
              marginLeft: "2rem",
              marginTop: "1rem",
              // marginTop: "0.5rem",
            }}
          >
            <PlusCircleOutlined style={{ color: "purple" }} />
            {capitalizeWords(props?.data?.[0]?.entity_level) || "Add"}
          </Button>
        )}
      {top && (
        <div
          style={{
            marginLeft: isCustomerSummary ? "0rem" : "8rem",
            marginBottom: "2rem",
            width: "100%",
          }}
        >
          <Form
            onFinish={onFinish2}
            ref={formRef2}
            form={form1}
            onValuesChange={handleFormChange}
          >
            <Row gutter={10} style={{ marginLeft: "0.5rem" }}>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item
                  name="entity_name"
                  rules={[
                    {
                      required: true,
                      message: "Name is required",
                    },
                  ]}
                >
                  <Input placeholder="Name" name="entity_name" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={10} lg={4} xl={4}>
                <Form.Item
                  name="entity_level"
                  initialValue={namingData.entity_label}
                >
                  <Input placeholder="level" name="entity_level" disabled />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item
                  name="entity_id"
                  style={{ flex: 1 }}
                  rules={[
                    {
                      validator: checkUserExists,
                      validateTrigger: "onChange",
                    },
                  ]}
                >
                  <Input placeholder="Hierarchy ID" name="entity_id" />
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={2} lg={2} xl={3}>
                <Form.Item name="structure">
                  <Input
                    placeholder="structure"
                    name="structure"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                <Form.Item name="users">
                  <Input
                    placeholder="Employee"
                    name="users"
                    style={{ display: "none" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <Form.Item name="manager" style={{ flex: 1 }}>
                  <Select placeholder="Manager" name="manager">
                    {props.manager?.map((app) => (
                      <Option key={app.id} value={app.id}>
                        {app.full_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3}>
                <Form.Item>
                  <div>
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{
                        background: "transparent",
                        border: "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "1.8rem",
                            height: "1.8rem",
                            borderRadius: "50%",
                            backgroundColor: "#52c41a",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CheckOutlined
                            title="submit"
                            style={{
                              color: "#fff",
                              fontSize: "1.2rem",
                              fontWeight: "700",
                            }}
                          />
                        </div>
                      </div>
                    </Button>
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.7rem",
                        marginLeft: "0.9rem",
                      }}
                      title="delete"
                      twoToneColor="#eb2f96"
                      onClick={() => {
                        setTop(false);
                        // handleReset();
                      }}
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      )}
      <DeactivationModal
        visible={modalVisible}
        onCancel={handleCancelModal}
        onDeactivate={handleDeactivation}
        onDelete={onDelete}
        record={selectedRecord}
        setRecord={setSelectedRecord}
        name={
          selectedRecord
            ? selectedRecord.entity_name ??
              selectedRecord.div_name ??
              selectedRecord.dep_name
            : ""
        }
        level={level}
        setLevel={setLevel}
        isCustomerSummary={isCustomerSummary}
        organizationId={props.organizationId}
      />
    </div>
  );
};

export default ParentTable;
